export const messageTypes = {
  choice: "choice",
  card: "card",
  text: "text",
  image: "image",
  video: "video",
};
export const bot = "bot";
